import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferenceIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 20,
	viewBox: "0 0 33 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M29 19C30.1046 19 31 18.1046 31 17V11C31 9.89543 30.1046 9 29 9H3C1.89543 9 1 9.89543 1 11V17C1 18.1046 1.89543 19 3 19H29Z",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.35156 2.73438H2.98926C3.31543 2.73438 3.59766 2.7832 3.83594 2.88086C4.07617 2.97852 4.26074 3.12305 4.38965 3.31445C4.51855 3.50586 4.58301 3.74219 4.58301 4.02344C4.58301 4.25781 4.54492 4.45703 4.46875 4.62109C4.39258 4.78516 4.28516 4.9209 4.14648 5.02832C4.00977 5.13574 3.84961 5.22266 3.66602 5.28906L3.35547 5.45898H1.96094L1.95508 4.71777H2.99219C3.13477 4.71777 3.25293 4.69238 3.34668 4.6416C3.44043 4.59082 3.51074 4.51953 3.55762 4.42773C3.60645 4.33398 3.63086 4.22461 3.63086 4.09961C3.63086 3.9707 3.60645 3.85938 3.55762 3.76562C3.50879 3.67188 3.43652 3.60059 3.34082 3.55176C3.24707 3.50098 3.12988 3.47559 2.98926 3.47559H2.30664V7H1.35156V2.73438ZM3.71289 7L2.75488 5.10449L3.7627 5.10156L4.73535 6.95605V7H3.71289ZM8.13086 6.26172V7H5.86035V6.26172H8.13086ZM6.18555 2.73438V7H5.23047V2.73438H6.18555ZM7.83789 4.45117V5.16602H5.86035V4.45117H7.83789ZM8.13379 2.73438V3.47559H5.86035V2.73438H8.13379ZM9.55469 2.73438V7H8.59961V2.73438H9.55469ZM11.2334 4.5332V5.27148H9.28809V4.5332H11.2334ZM11.4209 2.73438V3.47559H9.28809V2.73438H11.4209Z",
			fill: "#85A0AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 15C28.866 15 32 11.866 32 8C32 4.13401 28.866 1 25 1C21.134 1 18 4.13401 18 8C18 11.866 21.134 15 25 15Z",
			fill: "#FF3131",
			stroke: "white",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.692 4.61H24.297V6.878L24.477 8.993H25.512L25.692 6.86V4.61ZM24.324 11H25.674V9.686H24.324V11Z",
			fill: "white"
		})
	]
});
export default SvgReferenceIcon;
